import { Difficulty } from "../types";

export interface DifficultyConfig {
  gridSize: number;
  timeLimit: number;
  label: string;
  color: string;
}

export const DIFFICULTY_CONFIG: Record<Difficulty, DifficultyConfig> = {
  easy: { gridSize: 3, timeLimit: 15, label: "EASY", color: "#4ade80" },
  medium: { gridSize: 4, timeLimit: 105, label: "MEDIUM", color: "#facc15" },
  hard: { gridSize: 5, timeLimit: 180, label: "HARD", color: "#f87171" },
};
